import { Link } from '@tanstack/react-router';

const AUDIENCE_PAGES = [
  { slug: 'projektmanager', de: 'Projektmanager', en: 'Project Manager', deSub: 'Stakeholder-Kommunikation & Konflikte', enSub: 'Stakeholder Communication & Conflicts' },
  { slug: 'engineering-manager', de: 'Engineering Manager', en: 'Engineering Manager', deSub: 'Squad-Forming & Skill-Gaps', enSub: 'Squad Forming & Skill Gaps' },
  { slug: 'engineer', de: 'Engineer', en: 'Engineer', deSub: 'Individuelle Schätzungen & Sichtbarkeit', enSub: 'Individual Estimates & Visibility' },
  { slug: 'freelancer', de: 'Freelancer', en: 'Freelancer', deSub: 'Professionelle Planung ohne Enterprise-Kosten', enSub: 'Professional Planning Without Enterprise Costs' },
  { slug: 'platform-engineer', de: 'Platform Engineer', en: 'Platform Engineer', deSub: 'Infrastrukturkosten & Architekturentscheidungen', enSub: 'Infrastructure Costs & Architecture Decisions' },
] as const;

const FEATURE_PAGES = [
  { slug: 'discovery', de: 'Discovery', en: 'Discovery', deSub: 'Vom Board zum Projektplan', enSub: 'From Board to Project Plan' },
  { slug: 'pert', de: 'PERT-Schätzungen', en: 'PERT Estimates', deSub: 'Risiko wird eine Zahl', enSub: 'Risk Becomes a Number' },
  { slug: 'squad-forming', de: 'Squad-Forming', en: 'Squad Forming', deSub: 'Team-Zusammensetzung als Methode', enSub: 'Team Composition as Method' },
  { slug: 'adrs', de: 'ADRs', en: 'ADRs', deSub: 'Architekturentscheidungen dokumentieren', enSub: 'Document Architecture Decisions' },
  { slug: 'resources', de: 'Ressourcen & Kosten', en: 'Resources & Costs', deSub: 'Infrastrukturkosten im Plan', enSub: 'Infrastructure Costs in the Plan' },
] as const;

const text = {
  de: { heading: 'Lösungen für alle Rollen', featuresHeading: 'Features im Detail', backHome: 'Zurück zur Startseite' },
  en: { heading: 'Solutions for Every Role', featuresHeading: 'Features in Detail', backHome: 'Back to Home' },
} as const;

export function AudienceFooter({ lang, currentSlug, basePath = 'for' }: { lang: 'de' | 'en'; currentSlug: string; basePath?: string }) {
  const t = text[lang];

  return (
    <footer className="audience-footer">
      <div className="audience-footer-inner">
        <h3>{t.heading}</h3>
        <nav className="audience-crosslink-grid">
          {AUDIENCE_PAGES.map((page) => (
            <Link
              key={page.slug}
              to={`/${lang}/for/${page.slug}`}
              className={`audience-crosslink-card ${basePath === 'for' && page.slug === currentSlug ? 'audience-crosslink-card--active' : ''}`}
            >
              <span>{lang === 'de' ? page.de : page.en}</span>
              <small>{lang === 'de' ? page.deSub : page.enSub}</small>
            </Link>
          ))}
        </nav>

        <h3>{t.featuresHeading}</h3>
        <nav className="audience-crosslink-grid">
          {FEATURE_PAGES.map((page) => (
            <Link
              key={page.slug}
              to={`/${lang}/features/${page.slug}`}
              className={`audience-crosslink-card ${basePath === 'features' && page.slug === currentSlug ? 'audience-crosslink-card--active' : ''}`}
            >
              <span>{lang === 'de' ? page.de : page.en}</span>
              <small>{lang === 'de' ? page.deSub : page.enSub}</small>
            </Link>
          ))}
        </nav>

        <div className="audience-footer-bottom">
          <Link to="/">{t.backHome}</Link>
          <Link to={`/${lang}/legal/impressum`}>{lang === 'de' ? 'Impressum & AGB' : 'Legal & Terms'}</Link>
        </div>
      </div>
    </footer>
  );
}
